import { Controller } from "@hotwired/stimulus"

/**
 * Observability Session Expand Controller
 *
 * Toggles visibility of the session child row (which contains a Turbo Frame
 * that lazy-loads child requests). Rotates the chevron icon.
 */
export default class extends Controller<HTMLElement> {
  static targets = ["child", "icon"]
  static values = { expanded: Boolean }

  declare readonly childTarget: HTMLElement
  declare readonly iconTarget: HTMLElement
  declare expandedValue: boolean

  toggle() {
    this.expandedValue = !this.expandedValue
    this.childTarget.classList.toggle("hidden", !this.expandedValue)
    this.iconTarget.classList.toggle("rotate-90", this.expandedValue)
  }
}
